"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TrackingManager = exports.PREFIX_CUSTOM_EVENTS = void 0;
var _reactGa = _interopRequireDefault(require("react-ga4"));
var _objects = require("../objects");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PREFIX_CUSTOM_EVENTS = exports.PREFIX_CUSTOM_EVENTS = '[Custom]';
var TrackingManager = exports.TrackingManager = {
  init: function init() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      trackingId = _ref.trackingId,
      options = _ref.options;
    _reactGa["default"].initialize(trackingId, options);
  },
  setConfig: function setConfig() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      trackingId = _ref2.trackingId,
      options = _ref2.options;
    if (!_reactGa["default"].isInitialized) return;
    _reactGa["default"].gtag('config', trackingId, options);
  },
  trackPage: function trackPage() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$pagePath = _ref3.pagePath,
      pagePath = _ref3$pagePath === void 0 ? '' : _ref3$pagePath,
      _ref3$pageLocation = _ref3.pageLocation,
      pageLocation = _ref3$pageLocation === void 0 ? '' : _ref3$pageLocation,
      pageTitle = _ref3.pageTitle,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? {} : _ref3$options;
    if (!_reactGa["default"].isInitialized) return;
    _reactGa["default"].send(_objectSpread({
      hitType: 'pageview',
      page: pagePath,
      location: pageLocation,
      title: pageTitle
    }, options));
  },
  trackPageWithoutAutomaticSendPageView: function trackPageWithoutAutomaticSendPageView() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      trackingId = _ref4.trackingId,
      _ref4$pagePath = _ref4.pagePath,
      pagePath = _ref4$pagePath === void 0 ? '' : _ref4$pagePath,
      _ref4$pageLocation = _ref4.pageLocation,
      pageLocation = _ref4$pageLocation === void 0 ? '' : _ref4$pageLocation,
      pageTitle = _ref4.pageTitle,
      options = _ref4.options;
    if (!_reactGa["default"].isInitialized) return;
    _reactGa["default"].gtag('config', trackingId, {
      send_page_view: false
    });
    _reactGa["default"].send(_objectSpread({
      hitType: 'pageview',
      page: pagePath,
      title: pageTitle,
      location: pageLocation
    }, options));
  },
  trackEvent: function trackEvent() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      eventType = _ref5.eventType,
      eventDescription = _ref5.eventDescription,
      _ref5$prefixEvent = _ref5.prefixEvent,
      prefixEvent = _ref5$prefixEvent === void 0 ? PREFIX_CUSTOM_EVENTS : _ref5$prefixEvent,
      options = _ref5.options;
    var actionDescription = (0, _objects.isBlank)(prefixEvent) ? eventDescription : "".concat(prefixEvent, " ").concat(eventDescription);
    if (!_reactGa["default"].isInitialized) return;
    _reactGa["default"].event(_objectSpread({
      category: eventType,
      action: actionDescription
    }, options));
  }
};
var _default = exports["default"] = TrackingManager;